export { default } from './SingleBanner';
